// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","PostMenu__item--admin":"qw_a","PostMenu__item--moderator":"qw_b","PostMenu__item--author":"qw_c"};